<template>
  <div class="page-wrapper">
    <layout-header :title="$route.meta.title"></layout-header>
    <div class="layout-content" :style="{height:contentHeight}">
      <route-view></route-view>
    </div>
  </div>
</template>

<script>
import RouteView from '@/components/layouts/RouteView'
import LayoutHeader from '@/components/page/LayoutHeader'
export default {
  name: 'SubLayout',
  components: { RouteView, LayoutHeader },
  mounted () {
    this.contentHeight = document.documentElement.clientHeight - 50 + 'px'
  },
  data () {
    return {
      contentHeight: 0
    }
  }
}
</script>

<style lang="less" scoped>
  .layout-content{
    /*height: calc(100vh - 100px);*/
    overflow: auto;
  }
</style>
